var _rect, _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmactivityweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2074_27198)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#3B82F6",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2074_27198)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2074_27198",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H35V33H11V9Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2074_27198)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2074_27198",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H33V31H11V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2074_27198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9466 22.5649L30.1161 21.5078C30.3009 20.511 30.3009 19.4883 30.1161 18.4915L31.9466 17.4344C32.1571 17.3141 32.2516 17.0649 32.1828 16.8328C31.7059 15.3032 30.8939 13.9196 29.8325 12.768C29.6692 12.5918 29.4028 12.5489 29.1966 12.6692L27.3661 13.7262C26.5969 13.0645 25.7118 12.5532 24.7536 12.218V10.1082C24.7536 9.86762 24.586 9.65707 24.3496 9.60551C22.7727 9.25317 21.1571 9.27035 19.6575 9.60551C19.4212 9.65707 19.2536 9.86762 19.2536 10.1082V12.2223C18.2997 12.5618 17.4145 13.0731 16.6411 13.7305L14.8149 12.6735C14.6044 12.5532 14.3423 12.5918 14.179 12.7723C13.1176 13.9196 12.3055 15.3032 11.8286 16.8371C11.7555 17.0692 11.8544 17.3184 12.0649 17.4387L13.8954 18.4957C13.7106 19.4926 13.7106 20.5153 13.8954 21.5121L12.0649 22.5692C11.8544 22.6894 11.7598 22.9387 11.8286 23.1707C12.3055 24.7005 13.1176 26.084 14.179 27.2356C14.3423 27.4117 14.6087 27.4548 14.8149 27.3344L16.6454 26.2774C17.4145 26.9391 18.2997 27.4505 19.2579 27.7856V29.8996C19.2579 30.1403 19.4255 30.3508 19.6618 30.4024C21.2387 30.7548 22.8544 30.7376 24.3539 30.4024C24.5903 30.3508 24.7578 30.1403 24.7578 29.8996V27.7856C25.7118 27.4462 26.5969 26.9348 27.3703 26.2774L29.2009 27.3344C29.4114 27.4548 29.6735 27.416 29.8368 27.2356C30.8982 26.0883 31.7102 24.7048 32.1871 23.1707C32.2516 22.9344 32.1571 22.6852 31.9466 22.5649ZM22.0036 23.4371C20.1087 23.4371 18.5661 21.8946 18.5661 19.9996C18.5661 18.1047 20.1087 16.5621 22.0036 16.5621C23.8985 16.5621 25.4411 18.1047 25.4411 19.9996C25.4411 21.8946 23.8985 23.4371 22.0036 23.4371Z",
    fill: "#3B82F6"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_27198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2074_27198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmactivityweb);
export default __webpack_public_path__ + "static/media/crmactivityweb.ea728c0824eb8d3601ed60b1af7b81a2.svg";
export { ForwardRef as ReactComponent };